import { has } from 'lodash';
import { z } from 'zod';
import pathfinder from '@fiverr-private/pathfinder';
import { URI } from '@fiverr-private/futile';
import { buildQueryObject } from '../../../../utils/buildQueryObject';
import { SAFE_PATH_REGEX } from '../../constants';
import { logger } from '../../../../shared/logger';

const addLinkParams = (url, sourcePage, componentName, extraParams = {}) =>
    !url ? null : new URI(url).addParams(buildQueryObject(sourcePage, componentName, extraParams)).toString();

const categorySchema = z.string().regex(SAFE_PATH_REGEX).optional();
const articleIdSchema = z.string().regex(SAFE_PATH_REGEX).optional();

export const getCarouselHref = (urlData, dataEnrichment = {}) => {
    const { namedRoute, urlParams = {}, queryParams = {}, url } = urlData;
    const { sourceComponent, sourcePage, queryParameters: enrichedQueryParam } = dataEnrichment;

    try {
        categorySchema.parse(urlParams.category);
        articleIdSchema.parse(urlParams.article_id);
    } catch (error) {
        logger.error('Failed to get carousel href', {
            error,
            category: urlParams.category,
            article_id: urlParams.article_id,
        });

        return '/resources/guides/';
    }

    let link = !namedRoute ? url : pathfinder(namedRoute, urlParams);

    // TODO : Remove after https://github.com/fiverr/pathfinder/issues/45 is resolved
    if (namedRoute === 'education_hub' && has(urlParams, 'category') && has(urlParams, 'article_id')) {
        link = `/resources/guides/${urlParams.category}/${urlParams.article_id}`;
    }

    const linkWithParams = addLinkParams(link, sourcePage, sourceComponent, {
        ...enrichedQueryParam,
        ...queryParams,
    });

    return linkWithParams;
};
